import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Courseprovider } from './component/coursecontext/course_context';
import { Blogprovider } from './component/blogcontext/Blogcontext';
import { AllCourseprovider } from './component/allcoursecontaxt/ALLCoursecontaxt';
import { Cartprovider } from './component/cartcontaxt/cart_contaxt';
import { AuthProvider } from './component/Logincontaxt.jsx/Logincontex';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
     <QueryClientProvider client={queryClient}>
   <BrowserRouter>
      <Courseprovider>
         <Blogprovider>
               <AllCourseprovider>
                     <AuthProvider>
                      <Cartprovider>
                        <GoogleOAuthProvider clientId="566204704977-djj4r4emkg8r55ang59mapvbov9o7et4.apps.googleusercontent.com">
                             <App />
                           </GoogleOAuthProvider>
                         </Cartprovider>
                     </AuthProvider>
               </AllCourseprovider>
         </Blogprovider>
      </Courseprovider>
   </BrowserRouter>
   </QueryClientProvider>
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
